<template>
  <div
    class="fts-input-group"
    :class="[
      { 'input-group--items-start': placement === 'start' },
      { 'input-group--items-end': placement === 'end' },
    ]"
  >
    <!-- prepend -->
    <div
      class="input-group-prepend"
      v-if="Boolean($slots.prepend) || Boolean($scopedSlots.prepend)"
    >
      <slot name="prepend" />
    </div>
    <!-- slot -->
    <slot />
    <!-- append -->
    <div
      class="input-group-append"
      v-if="Boolean($slots.append) || Boolean($scopedSlots.append)"
    >
      <slot name="append" />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import FTSInputGroupIcon from "./FTSInputGroupIcon";

Vue.component("fts-input-group-icon", FTSInputGroupIcon);

export default {
  props: {
    placement: String,
  },
};
</script>

<style lang="scss" scoped>
.fts-input-group {
  width: 100%;
  display: flex;
  align-items: center;
  .input-group-prepend {
    display: flex;
    align-items: center;
    padding-right: 0.375rem;
  }
  .input-group-append {
    display: flex;
    align-items: center;
    padding-left: 0.375rem;
  }
  &.input-group--items-start {
    align-items: flex-start;
  }
  &.input-group--items-end {
    align-items: flex-end;
  }
}
</style>